"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(categoryId) {
    return 1018 <= categoryId && categoryId <= 1021;
}
exports.default = default_1;
